import React from "react";
import './InstagramPhoto.css'

interface IInstagramPhotoProps {
    image: string
    shortLink: string
}

export default function InstagramPhoto(props: IInstagramPhotoProps) {
    return <img className="Instagram_photo" src={props.image} onClick={(e) => { window.open(props.shortLink, "_blank") }}/>
}